import { trackError } from '~/services/logger/error.utils';

export class StorageService {
    private storage: Storage | null;

    constructor() {
        this.storage = this.getStorage();
    }

    private checkStorageAvailability(storage: Storage): boolean {
        try {
            const test = '__test__';
            storage.removeItem(test);
            return true;
        } catch {
            return false;
        }
    }

    private reportStorageError(error: Error, context: {} = null): void {
        trackError({
            error,
            message: `[Storage Error] ${error.message}`,
            context: {
                isLocalStorageAvailable:
                    this.checkStorageAvailability(localStorage),
                isSessionStorageAvailable:
                    this.checkStorageAvailability(sessionStorage),
                ...context
            }
        });
    }

    private getStorage(): Storage | null {
        if (this.checkStorageAvailability(localStorage)) {
            return localStorage;
        } else if (this.checkStorageAvailability(sessionStorage)) {
            return sessionStorage;
        }
        return null;
    }

    public setItem(key: string, value: string): void {
        try {
            this.storage.setItem(key, value);
        } catch (error) {
            this.reportStorageError(error);
        }
    }

    public getItem(key: string): string | null {
        try {
            return this.storage.getItem(key);
        } catch (error) {
            this.reportStorageError(error);
            return null;
        }
    }

    public removeItem(key: string): void {
        try {
            this.storage.removeItem(key);
        } catch (error) {
            this.reportStorageError(error);
        }
    }

    public clear(): void {
        try {
            this.storage.clear();
        } catch (error) {
            this.reportStorageError(error);
        }
    }

    public get length(): number {
        return this.storage.length;
    }
}
